<div id="NfoBottomSheetBar" class="popup-overlay" (click)="closeSheet()">
    <div class="popup-sheet" (click)="$event.stopPropagation()">
      <div class="TransPopCardHeader">
        <div class="HeadText">NFO</div>
        <div class="PopupCloseBtn" (click)="closeSheet()">
          <img src="../../../assets/images/img/x.svg" alt="">
        </div>
      </div>
      <div class="TransPopCardBody">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  